var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack543({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.76,12.08l-.66.85a3.83,3.83,0,0,1-.94-.66,2.37,2.37,0,0,1-.74.47,2.84,2.84,0,0,1-.93.14,2.06,2.06,0,0,1-1.61-.6,1.54,1.54,0,0,1-.42-1.07,1.64,1.64,0,0,1,.33-1,2.69,2.69,0,0,1,1-.76,3.29,3.29,0,0,1-.44-.66,1.4,1.4,0,0,1-.15-.6,1.11,1.11,0,0,1,.42-.88A1.75,1.75,0,0,1,7.78,7a1.62,1.62,0,0,1,1.16.38,1.19,1.19,0,0,1,.42.92,1.15,1.15,0,0,1-.21.66,2.59,2.59,0,0,1-.83.71l.8,1A3,3,0,0,0,9.36,10l1,.23a7.35,7.35,0,0,1-.26.77,2.22,2.22,0,0,1-.23.41,4.3,4.3,0,0,0,.47.37A3.13,3.13,0,0,0,10.76,12.08ZM7.34,10.16a1.46,1.46,0,0,0-.56.46.94.94,0,0,0-.19.55.78.78,0,0,0,.23.58.86.86,0,0,0,.62.23,1.39,1.39,0,0,0,.5-.1,2.18,2.18,0,0,0,.52-.34ZM7.77,9l.3-.23a.67.67,0,0,0,.33-.5.5.5,0,0,0-.16-.36.61.61,0,0,0-.43-.15.65.65,0,0,0-.41.13.4.4,0,0,0-.15.31.9.9,0,0,0,.25.49Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "7.78 0.75 0.28 15.24 15.28 15.24 7.78 0.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack543);
export default __webpack_public_path__ + "static/media/Symbolpack_5_43.db5445eee0aaa93f3b819c52d7cac899.svg";
export { ForwardRef as ReactComponent };